import WeeklySchedule from './weeklySchedule'
import MonthlySchedule from './monthlySchedule'

export default ({ patient, users, savePatient, saveAssignParticipant, createParticipant, deleteParticipant }) =>
  patient.packType === 'thrifty28days'
    ? (
    <MonthlySchedule patient={patient} users={users} savePatient={savePatient} saveAssignParticipant={saveAssignParticipant} createParticipant={createParticipant} deleteParticipant={deleteParticipant}/>
      )
    : (
    <WeeklySchedule patient={patient} users={users} savePatient={savePatient} saveAssignParticipant={saveAssignParticipant} createParticipant={createParticipant} deleteParticipant={deleteParticipant}/>
      )
